import { getCurrentBrowserFingerPrint } from "@rajesh896/broprint.js";
import { useEffect, useRef, useState } from "react";
import img from "/src/assets/img/icon.png"
import ButtonCheck from "../components/ui/button2";
import { Input } from "../components/ui/input";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import LabelStatus from "../components/ui/labelstatus";
import { useSearchParams } from "react-router-dom";
import { apiFetch } from "../lib/apiFetch";
export default function Absen() {
    const fingerprint = useRef<string>('')
    const absentype = useRef<string>("")
    const [titleButtonState, setTitleButtonState] = useState<string>("")
    const titleButton = useRef<string>("")
    const isRegister = useRef<boolean>(false)
    const [inputValue, setInputValue] = useState('');
    const [dataInitState, setDataInitState] = useState<any>("")
    const [jamlemburstate, setJamlemburstate] = useState<string>("")
    const baseurl = import.meta.env.VITE_KOPILIBRASI_URL
    const [searchParams] = useSearchParams();
    const getInitData = async (deviceId:string) => {
        const res = await apiFetch(baseurl + `/init_absen?device_id=${deviceId}`,
            {
                method: "GET",
                headers: {
                    "Accept" : "application/json",
                    "Content-Type": "application/json",
                },
            }
        )
        if (res.ok) {
            const data = await res.json()
            setDataInitState({...data})
            if(data.api_status == 1){
                setTitleButtonState("Absen Masuk")
                titleButton.current = "Absen Masuk"
                absentype.current = "checkin"
                if(data.data.id > 0){
                    isRegister.current = true
                    if(data.data.checkin_date != ""){
                        setTitleButtonState("Absen Keluar")
                        titleButton.current = "Absen Keluar"
                        absentype.current = "checkout"
                    }
                    if(data.data.checkout_date != ""){
                        setTitleButtonState("")
                        titleButton.current = ""
                    }
                    if(data.data.lembur > 0){
                        const tmpsplit: string[] = data.data.lembur_hour.split(":")
                        const lemburtext: string = tmpsplit[0] + " Jam, " + tmpsplit[1] + " Menit"
                        setJamlemburstate(lemburtext)
                    }
                }
            }
        }   
    }
    const handleChange = (event: any) => {
        setInputValue(event.target.value);
      };
    const handleAbsen = async (absentype: string) => {
        if(!isRegister.current && inputValue == ""){
            showSwal("Please input password", false)
        }else{
            const res = await apiFetch(baseurl + `/submit_absen?device_id=${fingerprint.current}&type=${absentype}&password=${inputValue}&token=${searchParams.get('token')}`,
            {
                method: "GET",
                headers: {
                    "Accept" : "application/json",
                    "Content-Type": "application/json",
                },
            })
            const data = await res.json()
            if(data.api_status == 1){
                showSwal(data.api_message, true)    
            }else{
                showSwal(data.api_message, false)    
            }
            getInitData(fingerprint.current)
        }
    }
    const showSwal = (title: string, type: boolean) => {
        withReactContent(Swal).fire({
          title: title,
          icon: type ? "success" : "error",
          showConfirmButton: false,
          timer: 1500
        })
      }
    useEffect(() => {
        getCurrentBrowserFingerPrint().then((v) => {
            fingerprint.current = v
            // setFingerprintState(fingerprint.current)
            getInitData(fingerprint.current)
        })
    }, [])
    return (
        <div className="h-screen w-screen justify-center bg-slate-200 pt-20">
            <div className="flex flex-col justify-center items-center">
                <span>
                    <img src={img} style={{ height: "100px" }} alt="icon" />
                </span>
                <h1 className='text-xl font-semibold tracking-wider font-cursive2'>Kopilibrasi</h1>
            </div>
            
            <div className="flex flex-col bg-white rounded-3xl mt-10">
                <div className="px-6 py-8 sm:p-10 sm:pb-6">
                    <div className="grid items-center justify-center w-full grid-cols-1 text-left">
                        <h2 className="text-lg font-medium tracking-tighter text-gray-600 lg:text-3xl text-center">
                            {
                                (dataInitState && dataInitState.data.id > 0) ? 
                                (
                                    <p>
                                        Selamat datang Kembali, <span className="font-semibold">{dataInitState.data.name}</span>
                                    </p>
                                )
                                : (
                                    dataInitState.api_message
                                )
                            }
                        </h2>
                    </div>
                    <div className="flex flex-col gap-3 mt-4">
                        {
                            (dataInitState && dataInitState.data.checkin_date != "") &&
                            <LabelStatus title="Absen Masuk" value={dataInitState.data.checkin_date} />
                        }
                        {
                            (dataInitState && dataInitState.data.checkout_date != "") &&
                            <LabelStatus title="Absen Keluar" value={dataInitState.data.checkout_date} />
                        }
                        {
                            (dataInitState && dataInitState.data.lembur > 0) &&
                            <LabelStatus title="Lemburan" value={jamlemburstate} />
                        }
                    </div>
                    <div className="flex justify-center items-center flex-col gap-3 mt-6">
                        {
                            !isRegister.current &&
                            <Input placeholder="Masukan Password" value={inputValue} onChange={handleChange}/>
                        }
                        {
                            (titleButton.current != "") &&
                            <ButtonCheck key={"buttonabsenmasuk"} title={titleButtonState} onClick={() => handleAbsen(absentype.current)} />
                        }
                    </div>
                </div>
                
            </div>

        </div>
    )
}